/* eslint-disable react-hooks/exhaustive-deps */
import { ClientDetailCard } from '@/components/entities/client/ClientDetailCard'
import { OrderDetailCard } from '@/components/entities/order/OrderDetailCard'
import { ProductDetailCard } from '@/components/entities/product/ProductDetailCard'
import { ButtonLinkBack } from '@/components/lib/ButtonLinkBack'
import useMediaQuery from '@/hooks/use-media-query'
import AuthService from '@/services/Auth/AuthService'
import CompanyService from '@/services/Company/CompanyService'
import OrderService from '@/services/Order/OrderService'
import UserService from '@/services/User/UserService'
// import UserService from '@/services/User/UserService'
import { BookingSlotType } from '@/types/BookingSlotType'
import { OrderType } from '@/types/OrderType'
import { UserType } from '@/types/UserType'
import {
  getMessageErrorSubmit,
  getOrderStatus,
  getOrderStatusTimeLine,
  setDateTime,
  setImageLocker,
  sortOrderHistory,
} from '@/utils/Functions'
import { flashStore } from '@/utils/Store'
import * as Sentry from '@sentry/react'
import { AxiosError, AxiosResponse } from 'axios'
import { Edit } from 'lucide-react'
import React from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  Image,
  ListGroup,
  Modal,
  Placeholder,
  Row,
  Spinner,
} from 'react-bootstrap'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useOutletContext, useParams } from 'react-router-dom'
import { HeaderOrderDetail } from './HeaderOrderDetail'

interface ShipperInputForm {
  firstName: string
  lastName: string
  id: number
}

interface BookingInputForm {
  booking_id: number
}

interface ApiResponse {
  response: AxiosResponse
  violations: Violation[]
}

interface Violation {
  propertyPath: string
  message: string
  code: string
}

type ContextType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>
}

const MD_BREAKPOINT = '(min-width: 769px)'

export const OrderDetail = () => {
  const isDesktop = useMediaQuery(MD_BREAKPOINT)
   const { setTitle } = useOutletContext<ContextType>()
    
    
  /* States / Hooks
   *******************************************************************************************/
  const param = useParams()
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const [orders, setData] = React.useState<OrderType>()
  const [showModalFormDeliverer, setShowModalFormDeliverer] = React.useState<boolean>(false)
  const [shippers, setShippers] = React.useState<UserType[]>([])
  const { register: registerShipper, handleSubmit: handleSubmitShipper } =
    useForm<ShipperInputForm>()
  const { register: registerBooking, handleSubmit: handleSubmitBooking } =
    useForm<BookingInputForm>()
  const [messageErrorInput, setMessageErrorInput] = React.useState()
  const flash = flashStore()
  const [onSubmitLoading, setOnSubmitLoading] = React.useState<boolean>(false)
  const [AuthUser, setAuthUser] = React.useState<UserType>()
  const [bookingSlots, setBookingSlot] = React.useState<BookingSlotType[]>([])
  const [showModalFormTemperatureZone, setShowModalFormTemperatureZone] =
    React.useState<boolean>(false)

  /* useEffect
   *******************************************************************************************/
  React.useEffect(() => {
    setTitle('Livraisons')
  }, [setTitle])

  React.useEffect(() => {
    getUserAuth(Number(param.id_order))
    // getData(Number(param.id_order))
  }, [param.id_order])

  /* Function / Events
   *******************************************************************************************/
  const getData = (orderId: number) => {
    if (AuthUser?.roles[0] === 'ROLE_SUPER_ADMIN' || AuthUser?.roles[0] === 'ROLE_ADMIN') {
      getDataForAdmin(orderId)
    } else {
      getDataForUser(orderId)
    }
  }

  const getDataForAdmin = async(orderId: number) => {
    setIsLoading(true)
    try{
      const response = await OrderService.getOrderByIdForAdmin(orderId)
       setData(response.data)
        if (response.data?.history.length > 0) {
          sortOrderHistory(response.data?.history)
        }
    }catch(error){
       flash.setMessageErrorFetch()
        Sentry.captureException(error)
    }finally{
      setIsLoading(false)
    }
    // OrderService.getOrderByIdForAdmin(orderId)
    //   .then((response: AxiosResponse) => {
    //     setData(response.data)
    //     if (response.data?.history.length > 0) {
    //       sortOrderHistory(response.data?.history)
    //     }
    //   })
    //   .catch((error: AxiosError) => {
    //     flash.setMessageErrorFetch()
    //     Sentry.captureException(error)
    //   })
  }
  const getDataForUser = async(orderId: number) => {
    setIsLoading(true)
    try{
      const response = await OrderService.getOrderByIdForUser(orderId)
      setData(response.data)
        if (response.data?.history.length > 0) {
          sortOrderHistory(response.data?.history)
        }
    }catch(error){
       flash.setMessageErrorFetch()
        Sentry.captureException(error)
    }finally{
      setIsLoading(false)
    }
   
  }

  const getUserAuth = (orderId: number) => {
    const storedUserAuth = localStorage.getItem(import.meta.env.VITE_APP_SESSION_USER)
    if (storedUserAuth) {
      const parsedUserData = JSON.parse(storedUserAuth)
      setAuthUser(parsedUserData)
      if (
        parsedUserData?.roles[0] === 'ROLE_SUPER_ADMIN' ||
        parsedUserData?.roles[0] === 'ROLE_ADMIN'
      ) {
        getDataForAdmin(orderId)
      } else {
        getDataForUser(orderId)
      }
    }
  }

  const handleCloseModalFormDeliverer = () => {
    setShowModalFormDeliverer(false)
  }

  const handleShowFormModalDeliverer = async() => {
    try {
      const response = await UserService.getAllUser()
      if (orders && orders?.company) {
        const idComp = orders?.company?.id
        const shippers = response.data['hydra:member']
          //filtré par rôle (livreur & super admin) et par compagnie
          .filter(
            (user: UserType) =>
              (user.roles.includes('ROLE_SHIPPER') ||
                user.roles.includes('ROLE_SUPER_ADMIN')) &&
              user.memberships[0]?.id === idComp
          )
          //trié par ordre alphabétique
          .sort((a: UserType, b: UserType) =>
            a.firstName.localeCompare(b.firstName, 'fr', {
              sensitivity: 'base',
            })
          )
        setShippers(shippers)
      }
    } catch (error) {
      console.info(error)
    } finally {
      setShowModalFormDeliverer(true)
    }
  }

  // Assignement livreur
  const onSubmitShipper: SubmitHandler<ShipperInputForm> = (shipper) => {
    setOnSubmitLoading(true)
    const data = { shippedBy: 'api/users/' + shipper.id }
    OrderService.update(Number(param.id_order), data)
      .then(() => {
        flash.setMessage('success', 'Livreur assigné !')
      })
      .catch((error: ApiResponse) => {
        if (error?.response?.data?.violations?.length > 0) {
          flash.setMessageErrorValidator()
          setMessageErrorInput(error.response.data.violations)
        } else {
          flash.setMessageErrorForm()
          Sentry.captureException(error)
        }
      })
      .finally(() => {
        getData(Number(param.id_order))
        setOnSubmitLoading(false)
        setShowModalFormDeliverer(false)
      })
  }

  // Handle to change temperature zone
  const handleCloseModalFormTemperatureZone = () => {
    setShowModalFormTemperatureZone(false)
  }

  const handleShowModalFormTemperatureZone = async() => {
    const company_id: number = Number(orders?.company?.id)
    try{

      const response = await CompanyService.getBookingsByCompanyId(company_id, 1, 50)
      console.log(response)
      setBookingSlot(response.data['hydra:member'])
    }catch(error: unknown){
      if(error instanceof AxiosError){

        AuthService.refreshToken()
        Sentry.captureException(error)
      }
    }finally{
      setShowModalFormTemperatureZone(true)
    }
  }

  const onSubmitBooking: SubmitHandler<BookingInputForm> = (data) => {
    const order_id: number = Number(param?.id_order)
    const bookingSlot = { bookingSlot: '/api/booking_slots/' + data?.booking_id }
    setOnSubmitLoading(true)

    OrderService.update(order_id, bookingSlot)
      .then(() => {
        flash.setMessage('success', 'La zone de température a bien été changée.')
      })
      .catch((error: ApiResponse) => {
        if (error?.response?.data?.violations?.length > 0) {
          flash.setMessageErrorValidator()
          setMessageErrorInput(error.response.data.violations)
        } else {
          flash.setMessageErrorForm()
          Sentry.captureException(error)
        }
      })
      .finally(() => {
        getData(Number(param.id_order))
        setOnSubmitLoading(false)
        setShowModalFormTemperatureZone(false)
      })
  }


  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row className='w-100 gap-2'>
        <Col xs={2}>
          <ButtonLinkBack />
        </Col>
        <Col className='text-center'>
          <HeaderOrderDetail isDesktop={isDesktop} param={param} data={orders} />
        </Col>
        <Col xs={2}></Col>
      </Row>
      {/* Summary */}
      <Row xs={2} md={3} className='mt-4'>
        <Col lg={4} xs={6}>
          <Card className='mb-3 mb-md-0'>
            <Card.Body className='d-flex align-items-center'>
              <div className='flex-shrink-0 avatar-sm me-3'>
                <div className='avatar-title text--primary fs-22 rounded'>
                  <i className='ri-list-check-2 ri-2x'></i>
                </div>
              </div>
              <div className={`flex-grow-1`}>
                <h5 className={`mb-0 ${!isDesktop && 'font-65'}`}>Statut</h5>
                <h6 className={`mb-0 mt-2 ms-1 ${!isDesktop && 'font-75'}`}>
                  {isLoading ? (
                    <Placeholder as={Card.Title} animation='glow' className='font-65'>
                      <Placeholder xs={6} className='rounded' />
                    </Placeholder>
                  ) : (
                    getOrderStatus(orders?.status)
                  )}
                </h6>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} xs={6}>
          <Card className='mb-3 mb-md-0'>
            <Card.Body className='d-flex align-items-center'>
              <div className='flex-shrink-0 avatar-sm me-3'>
                <div className='avatar-title text--primary fs-22 rounded'>
                  <i className='ri-map-pin-line ri-2x'></i>
                </div>
              </div>
              <div className='flex-grow-1'>
                <h5 className='d-none d-md-block mb-0'>Adresse de la machine</h5>
                {isLoading ? (
                  <>
                  <Placeholder as={'h6'} animation='glow' className='d-none d-md-block mt-2 font-65'>
                    <Placeholder xs={4} className='rounded' />
                  </Placeholder>
                  <Placeholder as={Card.Title} animation='glow' className='font-65'>
                    <Placeholder xs={2} className='rounded' />
                  </Placeholder>
                  </>
                ) : (
                  <>
                    <h6 className={`d-none d-md-block mb-0 ms-1 mt-2 `}>
                      {orders?.locker?.location}
                      <br />
                    </h6>
                    <small className={`${!isDesktop && 'font-65'}`}>
                      {orders?.locker?.shortLocation}
                    </small>
                  </>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} xs={12}>
          <Card>
            <Card.Body className='d-flex align-items-center'>
              <div className='flex-shrink-0 avatar-sm me-3'>
                <div className='avatar-title text--primary fs-22 rounded'>
                  <i className='ri-temp-cold-line ri-2x'></i>
                </div>
              </div>
              <div className='flex-grow-1 '>
                <Edit
                  size={18}
                  onClick={handleShowModalFormTemperatureZone}
                  className='ms-3 text-danger cursor-pointer float-end'
                />
                <h5 className='d-none d-md-block mb-0'>Zone de température</h5>
                <h6 className={`${!isDesktop ? 'font-65' : ' '} mb-0`}>
                  {isLoading ? (
                    <Placeholder as={Card.Title} animation='glow' className='font-65'>
                      <Placeholder xs={1} className='rounded' /> -{' '}
                      <Placeholder xs={2} className='rounded' />
                    </Placeholder>
                  ) : (
                    <>
                      {orders?.bookingSlot?.slot?.temperatureZone?.myKey} -{' '}
                      {orders?.bookingSlot?.slot?.temperatureZone?.name}
                    </>
                  )}
                </h6>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col lg={8}>
          <Card className='mb-4'>
            <Card.Header>
              <h5 className='mt-2'>Historique de la commande</h5>
            </Card.Header>
            <Card.Body className='py-3 px-5'>
              <ul className='timeline'>
                {orders?.history !== undefined && orders?.history?.length > 0 ? (
                  orders?.history
                    .reverse()
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .map((h: any, i: number) => (
                      <li key={i} className={i === history.length - 1 ? 'active' : ''}>
                        <h6 className='mb-0 text--primary fw-bold'>
                          {getOrderStatusTimeLine(h?.status)}
                        </h6>
                        <>
                          <p className='text-muted mb-0'>{setDateTime(h?.createdAt)}</p>
                        </>
                      </li>
                    ))
                ) : (
                  <li>
                    <h6 className='mb-0 text--primary fw-bold'>Commande créée</h6>
                    <p className='text-muted mb-0'>
                      {orders?.createdAt && setDateTime(orders?.createdAt)}
                    </p>
                  </li>
                )}
              </ul>
            </Card.Body>
          </Card>
          <OrderDetailCard order={orders} />
        </Col>
        <Col lg={4}>
          <ClientDetailCard client={orders?.client} />
          <ProductDetailCard order={orders} />

          <Card className='mb-4'>
            <Card.Header>
              <h5 className='mt-2'>Adresse de livraison</h5>
            </Card.Header>
            <Card.Body className='p-3'>
              <Row>
                <Col lg={5}>
                  {orders?.locker?.type !== undefined && (
                    <Image
                      src={setImageLocker(orders?.locker?.type)}
                      alt={'Locker'}
                      className='img-thumbnail mb-3'
                    />
                  )}
                </Col>
                <Col lg={7}>
                  <ListGroup as='ul' variant='flush'>
                    <ListGroup.Item as='li' className='py-2'>
                      Livreur :{' '}
                      {orders?.shippedBy?.firstName !== undefined ? (
                        <>
                          <Edit
                            size={18}
                            className='ms-3 text-danger cursor-pointer float-end'
                            onClick={handleShowFormModalDeliverer}
                          />
                          {orders?.shippedBy?.firstName + ' ' + orders?.shippedBy?.lastName}
                        </>
                      ) : (
                        <>
                          <Edit
                            size={18}
                            className='ms-3 text-danger cursor-pointer float-end'
                            onClick={handleShowFormModalDeliverer}
                          />
                          <span>Aucun livreur assigné</span>
                        </>
                      )}
                    </ListGroup.Item>
                    <ListGroup.Item as='li' className='py-2'>
                      Destination : {orders?.locker?.location}
                      <br />
                      {orders?.locker?.shortLocation}
                    </ListGroup.Item>
                    <ListGroup.Item as='li' className='py-2'>
                      Commune : {orders?.locker?.city}
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          {/* <Card className="mb-4 text-center">
            <Card.Header>
              <h5 className="mt-2">QRCode retrait</h5>
            </Card.Header>
            <Card.Body className="p-3">
              <QRCode value={data.receiveCode} />
              <br />
              <br />
              <small>Saisie maunelle : {data.receiveCode}</small>
            </Card.Body>
          </Card> */}
        </Col>
      </Row>
      {/* Modal Form Deliverer > Assign deliverer */}
      <Modal show={showModalFormDeliverer} onHide={handleCloseModalFormDeliverer}>
        <Modal.Header closeButton>
          <Modal.Title>Assigner un livreur</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmitShipper(onSubmitShipper)}>
          <Modal.Body>
            <Form.Select
              aria-label='Default select example'
              className='form-control'
              {...registerShipper('id')}
            >
              <option>-- Sélectionnez un livreur --</option>
              {shippers?.map((shipper: UserType) => (
                <option value={shipper?.id} key={shipper?.id}>
                  {shipper?.firstName + ' ' + shipper?.lastName}
                </option>
              ))}
            </Form.Select>
            {messageErrorInput && (
              <small className='text-danger'>
                {getMessageErrorSubmit(messageErrorInput, 'id')}
              </small>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleCloseModalFormDeliverer}>
              Annuler
            </Button>
            <Button type='submit' variant='dark'>
              {onSubmitLoading ? <Spinner size={'sm'} /> : 'Enregistrer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Modal Form TemperatureZone > Change zone */}
      <Modal show={showModalFormTemperatureZone} onHide={handleCloseModalFormTemperatureZone}>
        <Modal.Header closeButton>
          <Modal.Title>Changer de zone de température</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmitBooking(onSubmitBooking)}>
          <Modal.Body>
            <Form.Select
              aria-label='Default select example'
              className='form-control'
              {...registerBooking('booking_id')}
            >
              <option>-- Sélectionnez une zone de température --</option>
              {bookingSlots?.map(
                (bookingSlot: BookingSlotType) =>
                  bookingSlot?.available !== 0 && (
                    <option value={bookingSlot?.id} key={bookingSlot?.id}>
                      {bookingSlot?.slot?.temperatureZone?.locker?.shortLocation} -{' '}
                      {bookingSlot?.slot?.temperatureZone?.name} - H{bookingSlot?.slot?.height}{' '}
                      x L{bookingSlot?.slot?.width} x P{bookingSlot?.slot?.depth}
                    </option>
                  )
              )}
            </Form.Select>
            {messageErrorInput && (
              <small className='text-danger'>
                {getMessageErrorSubmit(messageErrorInput, 'id')}
              </small>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleCloseModalFormTemperatureZone}>
              Annuler
            </Button>
            <Button type='submit' variant='dark'>
              {onSubmitLoading ? <Spinner size={'sm'} /> : 'Enregistrer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}
